import { Route } from 'react-router-dom'
import { ID_PERFIL_ADMIN_EBP } from '../../constants/perfiles'
import RutaProtegidaPorPerfil from '../hoc/RutaProtegidaPorPerfil'
import Pedidos from '../pedidos/Pedidos'

const proteger = (element) => (
  <RutaProtegidaPorPerfil perfilesPermitidos={[ID_PERFIL_ADMIN_EBP]}>
    {element}
  </RutaProtegidaPorPerfil>
)

const AdminEBPRoutes = () => (
  <>
    <Route path="/PedidosEBM" element={proteger(<Pedidos />)} />
  </>
)

export default AdminEBPRoutes
